<div class="">
	<div class="font-weight-bold mb-2">Have Questions?</div>
	<div class="mb-3 body-size">Find answers to our most commonly asked questions by visiting our <a [routerLink]="['/support/faq']" >FAQ page.</a></div>
	<div class="d-flex  body-size">
		<div class=""><a href="tel:14142313236" class="text-decoration-none"><fa-icon [icon]="['fas', 'phone-volume']" class="mr-1"></fa-icon> (414) 231-3236</a></div>
		<div class="d-block mx-2">|</div>
		<div class=""><a [routerLink]="['/support/contact-us']" class="text-decoration-none"><fa-icon [icon]="['fas', 'comments']" class="mr-1"></fa-icon> Contact Us</a></div>
	</div>
</div>
